import { hasSession } from '../../security/session';

class Auth{
  
    login(cb){
        this.authenticated=true;
        cb()
    }
    logout(cb){
        this.authenticated=false;
        cb()
    }

    isAuthenticated(){
        return hasSession();
                 
    }


}
export default new Auth()
